<template>
  <div style="height: calc(100vh - 135px);overflow: auto;padding-right:8px">
    <!-- <div class="page_header" > -->
    <div style="display: flex; align-items: center; margin-top: 25px">
      <div style="flex: 1">
        <!-- <div class="page_title">{{ $t('alarm.page_title') }}</div> -->
        <span class="page_title">{{ $t("alarm.page_title") }}</span>
        <span
          v-show="noteShow"
          style="font-size: 12px; color: #ff8c00; margin-left: 16px"
        >
          <i
            class="iconfont icon-icon_prompt2"
            style="font-size: 16px; margin-right: 4px"
          ></i>
          {{ $t("alarm.page_alarm") }}
        </span>
        <el-tooltip class="item" effect="light" :content="$t('alarm.page_alarm')" placement="top-start" v-show="!noteShow">
          <span
            style="font-size: 12px; color: #ff8c00; margin-left: 16px"
          >
            <i
              class="iconfont icon-icon_prompt2"
              style="font-size: 16px; margin-right: 4px"
            ></i>
          </span>
        </el-tooltip>
      </div>
      <div>
        <quickQuery
          :speedShow="false"
          :isNow="false"
          @handleQuery="handleQuery"
          @quickQuery="quickQuery"
          @download="download"
          style="flex: 1; text-align: right"
        />
      </div>
    </div>
    <div class="alarmSta">
      <el-row :gutter="16">
        <el-col :span="12">
          <div class="alarmStaRow">
            <div>{{$t('alarm.报警类型占比')}}</div>
            <div style="display:flex;height: 100%;">
              <div style="flex:2.5">
                <div v-loading="loading" id="ringChart"  style="width:100%; height:100%;"></div>
              </div>
              <div class="chartsLabel" style="">
                <div v-for="(item,index) in alarmTypeChart" :key="item.name" :value="item.value">
                  <div style="display:inline-flex;margin-top: 16px;">
                    <div class="tag" :style="{'background': chartColor[index]}"></div>
                    <div class="tagText">{{item.name}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="alarmStaRow">
            <div>{{$t('alarm.报警车辆排名')}}</div>
            <div v-loading="barLoading" id="barChart" style="width:100%;height:100%;"></div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="alarmlist">
      <el-table
        v-loading="loading"
        :size="size"
        :data="alarmData"
        border
        style="width: 100%"
        id="Data"
      >
        <el-table-column prop="alarmType" :label="alarmType" align="center">
          <template slot-scope="scope">
            <el-tag :size="size">{{scope.row.alarmType}}</el-tag>
            <!--<el-tag :size="size">{{
              $t("alarm.alarmType" + scope.row.id)
            }}</el-tag>-->
          </template>
        </el-table-column>

        <el-table-column
          prop="alarmNum"
          :label="alarmNum"
          align="center"
        >
          <template slot-scope="scope"><span :style="{'color': scope.row.alarmNum >0 ? '#FF106E': null}">{{scope.row.alarmNum}}</span></template>
        </el-table-column>

        <el-table-column
          prop="UnDeal"
          :label="UnDeal"
          align="center"
        >
          <template slot-scope="scope"><span :style="{'color': scope.row.UnDeal >0 ? '#FF106E': null}">{{scope.row.UnDeal}}</span></template>
        </el-table-column>

        <el-table-column
          prop="Deal"
          :label="Deal"
          align="center"
        >
          <template slot-scope="scope"><span :style="{'color': scope.row.Deal >0 ? '#07B477': null}">{{scope.row.Deal}}</span></template>
        </el-table-column>

        <el-table-column
          prop="DealPercent"
          :label="DealPercent"
          align="center"
        ></el-table-column>

        <el-table-column prop="export" :label="export2" align="center">
          <template slot-scope="scope">
            <el-button
              :disabled="!clickFlag(scope.row)"
              :data="list"
              size="mini"
              type="text"
              style="padding: none"
              @click="exportdata(scope.row)"
              id="tableData"
              >{{ $t("public.download") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
 
import quickQuery from "../../statistics/components/generalOrQuickQuery.vue";
import { exportJsonToExcel } from "../../../utils/Export2Excel.js";
// import * as echarts from "echarts";
import settings from "@/settings";
import language from '@/utils/getLanguageId'
export default {
    name:"alarmdata",
  components: {
    quickQuery,
    // htmlToExcel
  },
  data() {
    return {
      chartColor:['#1461E1', '#09B2F3', '#21C189', '#EF8B11', '#c858ff', '#EC5353', '#98e51c', ],
      alarmTypeChart:[],
      loading: false,
      barLoading: false,
      form: {},
      showBtn: undefined, //按钮默认选中：今天
      noteShow: false,
      alarmData: [],
      detailData: [],
      screenWidth: undefined,// document.body.clientWidth,
      searchTime: [
        this.moment(
          new Date(new Date().getTime() - 3600 * 1000 * 24 * 7)
        ).format("YYYY-MM-DD"),
        this.moment(new Date()).format("YYYY-MM-DD"),
      ],
      searchType: 1,

      alarmType: this.$t("alarm.alarmType"),
      alarmNum: this.$t("alarm.alarmNum"),
      UnDeal: this.$t("alarm.UnDeal"),
      Deal: this.$t("alarm.Deal"),
      DealPercent: this.$t("alarm.DealPercent"),
      export2: this.$t("alarm.export"),
      ringChartData:[],
      ringChart:undefined,
      barChart:undefined,
      barChartData:[],
      LanguageId:1,
      ringChartDom:undefined,
    };
  },
  computed: {
    searchShow() {
      return this.searchType == 0 ? true : false;
    },
    size() {
      return this.$store.getters.size;
    },
    list() {
      return this.detailData;
    },
  },
  mounted() {
       const currentPath = this.$route.path
    // 从全局变量中取出对应路由的开始时间
    const startTime = settings.routeStartTime[currentPath]
    if (startTime) {
      // 计算耗时（mounted时组件已挂载到DOM，UI基础展示完成）
      const renderTime = Date.now() - startTime
      console.log(`路由 ${currentPath} 渲染耗时：${renderTime}ms`)
      // 可选：上报到后端或日志系统
      // reportRenderTime(currentPath, renderTime)

      // 清除已计算的开始时间，避免重复计算
      delete settings.routeStartTime[currentPath]
    }
    this.screenWidth = document.body.clientWidth;
    this.LanguageId = language(this.$store.getters.locale)
    const that = this;
    window.onresize = () =>
      (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
    // this.searchTime();
    this.$nextTick(()=>{
      this.initChart();
      // this.setBarChart();
      // this.setRingChart();
      this.setResize();
    });
    window.addEventListener('resize',this.setResize)
  },
  activated(){
    this.$nextTick(()=>{
      this.setResize();
    });
    window.addEventListener('resize',this.setResize);
  },
  watch: {
    screenWidth(val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = val;
        this.timer = true;
        const that = this;
        setTimeout(function () {
          if (that.screenWidth >= 1640) {
            that.noteShow = true;
          } else that.noteShow = false;
          that.timer = false;
        }, 10);
      }
      deep: true;
    },
  },

  methods: {
    setResize(){
      this.ringChart.resize();
      this.barChart.resize();
    },
    setBarChart(xData,yData){
      var optionBar= {
          title:{},
          legend: {

          },
          grid: {
            left: '5%',
            right: '13%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            minInterval:1,
            name: this.$t('alarm.报警数量'),
            type: 'value',
            splitLine: {
                show: false
            },
            boundaryGap: [0, 0.01],
          },
          yAxis: {
            name: this.$t('alarm.报警车辆'),
            type: 'category',
            data: yData?yData:[],
          },
          series: [
            {
              type: 'bar',
              barWidth:15,
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  { offset: 0, color: '#C8DCFF' },
                  { offset: 0.4, color: '#7dadff' },
                  { offset: 1, color: '#2A7AFF' }
                ])
              },
              data:xData?xData:[],
              label:{
                show:true,
                position: 'right', // 标签位置
              }
            }
          ]

        };
        this.barChart.setOption(optionBar,true);
    },
    initChart(){
      this.barChart = echarts.init(document.getElementById("barChart"));
      this.ringChart = echarts.init(document.getElementById("ringChart"));
      this.ringChartDom = document.getElementById('ringChart');
    },
    setRingChart(data){
      const _this = this;
      var option = {
        series:{
          type: 'pie',
          radius: ["30%", "55%"],
          top: 0 + '%',
          height: '100%',
          left: 'center',
          // width: 400,
          width: "100%",
          label: {
            alignTo: 'edge',
            formatter: '{name|{b}}\n{time|{c} %}',
            minMargin: 5,
            edgeDistance: 10,
            lineHeight: 15,
            rich: {
              time: {
                fontSize: 12,
                color: '#999',
                // fontWeight: 'bold',
                },
              name:{
                fontSize: 14,
                color: "#0E193B",
              }
            }
          },
          labelLine: {
            length: 15,
            length2: 0,
            maxSurfaceAngle: 80
          },
          labelLayout: function (params) {
            
            const chartWidth = _this.ringChartDom.offsetWidth; 

            const isLeft = params.labelRect.x < chartWidth / 2;
            
            const points = params.labelLinePoints;
            
            points[2][0] = isLeft
              ? params.labelRect.x
              : params.labelRect.x + params.labelRect.width;
            return {
              labelLinePoints: points
            };
          },
          itemStyle: {
            color: function (params) { // 参数名改为 params 更规范
              return _this.chartColor[params.dataIndex % _this.chartColor.length];
            },
            borderColor: '#fff',//每个颜色之间的间隙颜色
            borderWidth: 1.5,//间隙宽度
          },
          data: data ? data : []
        }
        
      }
      this.ringChart.setOption(option,true);
    },
    
    download() {
      if (this.alarmData.length == 0) {
        this.$message.error(this.$t("statistics.PleQuery"));
        return;
      }
      this.loading = true;
      var totalName =
        this.$t("alarm.page_title") +
        this.moment(new Date()).format("YYYY-MM-DD ");
      // const data=this.alarmData;

      let data2 = [];
      for (let i = 0; i < this.alarmData.length; i++) {
        let data1 = []; //设置一个二级列表，导出的表格每一行为一个二级列表

        this.alarmData[i].alarmType = this.$t(
          "alarm.alarmType" + this.alarmData[i].id
        );

        data1.push(
          this.alarmData[i].alarmType,
          this.alarmData[i].alarmNum,
          this.alarmData[i].UnDeal,
          this.alarmData[i].Deal,
          this.alarmData[i].DealPercent
        );
        data2.push(data1); //把二级列表塞入一级列表
      }
      exportJsonToExcel({
        header: [
          this.$t("alarm.alarmType"),
          this.$t("alarm.alarmNum"),
          this.$t("alarm.UnDeal"),
          this.$t("alarm.Deal"),
          this.$t("alarm.DealPercent"),
        ],
        filename: totalName,
        data: data2, //
      });

      this.loading = false;
    },

    handleQuery(val) {
      this.form = val;
      delete this.form.pageNum;
      delete this.form.pageSize;

      this.getData();
      this.getBarData();
    },
    quickQuery(val) {
      this.form = val;
      delete this.form.pageNum;
      delete this.form.pageSize;

      this.getData();
      this.getBarData();
    },
    getData() {
      this.loading = true;
      this.$api
        .alarmInfo({
          StartDate: this.form.beginDate,
          EndDate: this.form.endDate,
          OperatorID: this.$store.getters.operator.OperatorId,
          // SubjectCorpID: this.$store.getters.operator.CompanyId,
          LanguageID: this.LanguageId,
        })
        .then((res) => {
          this.loading = false;
          if (res.data.length > 0) {
            this.alarmTypeChart = [];
            this.alarmData = res.data;
            var otherValPer = 0;

            this.alarmData.forEach((element,index)=>{
              if(index < 6 ){
                this.alarmTypeChart.push({
                  name:element.alarmType,
                  value: element.AlarmPercent,
                })
              }else{
                otherValPer += element.AlarmPercent;
              }
            })
            if(this.alarmData.length > 6){
              this.alarmTypeChart.push({
                name: this.$t("speedlimit.其他"),
                value: otherValPer.toFixed(2),
              })
            }
            // console.log(otherValPer);
            
            // console.log(this.alarmTypeChart)
            this.setRingChart(this.alarmTypeChart);
            
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getBarData(){
      this.barLoading = true;
      this.$api
        .queryVehicleAlarmRanking({
          BeginTime: this.form.beginDate,
          EndTime: this.form.endDate,
        })
        .then((res)=>{
          this.barLoading = false;
          if(res.code == 200){

          }
          let xData = [];
          let yData = [];
          res.data.forEach((element)=>{
            xData.push(element.AlarmCount);
            yData.push(element.CarNo);
          })
          console.log(xData,yData);
          // this.setBarChart([50,5,25,33,40],[1,2,3,4,5]);
          this.setBarChart(xData.reverse(),yData.reverse());
        })
    },
    exportdata(row) {
      this.loading = true;

      this.$api
        .alarmdetail({
          StartDate: this.form.beginDate,
          EndDate: this.form.endDate,
          AlarmType: row.id,
          OperatorID: this.$store.getters.operator.OperatorId,
          SubjectCorpID: this.$store.getters.operator.CompanyId,
        })
        .then((res) => {
          this.loading = false;
          if (res.data.length > 0) {
            for (let i = 0; i < res.data.length; i++) {
              if (res.data[i].Location == null) {
                res.data[i].Location = "";
              }
            }
            this.detailData = res.data;
            let data2 = [];
            var detailName;
            for (const i in res.data) {
              let data1 = []; //设置一个二级列表，导出的表格每一行为一个二级列表

              this.detailData[i].AlarmType = this.$t(
                "alarm.alarmType" + row.id
              );
              detailName = this.$t("alarm.alarmType" + row.id);

              if (this.detailData[i].AlarmState == this.$t("alarm.Deal1")) {
                this.detailData[i].AlarmState = this.$t("alarm.Deal1");
              } else {
                this.detailData[i].AlarmState = this.$t("alarm.Deal2");
              }

              this.detailData[i].AlarmSource = this.$t("alarm.Source");
              this.detailData[i].StartTime = this.moment(
                this.detailData[i].StartTime
              ).format("YYYY/MM/DD HH:mm:ss");

              this.detailData[i].EndTime = this.moment(
                this.detailData[i].EndTime
              ).format("YYYY/MM/DD HH:mm:ss");

              data1.push(
                this.detailData[i].CarNo,

                this.detailData[i].AlarmType,
                this.detailData[i].AlarmState,
                this.detailData[i].StartTime,
                this.detailData[i].EndTime,
                this.detailData[i].AlarmSource,
                this.detailData[i].Location
              );
              data2.push(data1); //把二级列表塞入一级列表
            }
            console.log(data2);
            let filename =
              detailName +
              this.moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
            exportJsonToExcel({
              header: [
                this.$t("alarm.carNo"),
                this.$t("alarm.alarmType"),
                this.$t("alarm.alarmState"),
                this.$t("alarm.startTime"),
                this.$t("alarm.endTime"),
                this.$t("alarm.alarmSource"),
                this.$t("alarm.location"),
              ],
              filename: filename,
              data: data2,
            });
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    clickFlag(row) {
      if (row.alarmNum > 0) {
        return true;
      } else return false;
    },
  },
};
</script>

<style lang="scss" scoped>


.form   {
  ::v-deep .el-form-item {
    margin-bottom: 0px !important;
    margin-right: 0px !important;
  }
  ::v-deep  .el-form-item__label {
    font-size: 12px;
  }
}

.alarmlist {
  margin-top: 20px;
  ::v-deep .el-table tr {
    background: transparent;
  }

  ::v-deep.el-table {
    background: transparent;
  }

  ::v-deep .el-table td {
    background: transparent;
  }
}
.time {
  margin-left: 5px;
  // width:53px;
  text-align: center;
}
.el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /*height:600px;*/
  max-height: calc(100% - 200px);
  max-width: calc(100% - 30px);
}
.el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}
.alarmStaRow{
  height:422px;
  background: #E8F0FF;
  border: 1px solid #C5D0E2;
  font-weight: 600;
  font-size: 14px;
  color: #0E193B;
  padding: 20px;
}
.tag{
  width: 32px;
  height: 16px;
  // background: #1461E1;
  border-radius: 2px;margin-right:12px
}
.tagText{
  flex: 1;
  font-weight: 400;
  font-size: 14px;
  color: #0E193B;
  text-align: left;
   word-wrap: break-word; /* 强制换行 */
}
.chartsLabel{
  flex:1;
  display: flex; 
  flex-direction: column;
  justify-content: center;
  // margin-left: 16px;
}
</style>
